export { default } from './ResearchCoverage';
